import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7cf7fe99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dropdown" }
const _hoisted_2 = {
  class: "btn btn-secondary dropdown-toggle border-1 border-white rounded-4",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "dropdown-menu dropdown-menu-end bg-dark" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["src"]

import { useLanguageSwitcher } from "@/composables/languageSwitcher";


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSwitcher',
  setup(__props) {

const { changeLocale, selectedLocale, availableLocales } =
  useLanguageSwitcher();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", _hoisted_2, [
      _createElementVNode("img", {
        src: _unref(selectedLocale).flag,
        alt: "Flag"
      }, null, 8, _hoisted_3)
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableLocales), (loc) => {
        return (_openBlock(), _createElementBlock("li", {
          onClick: ($event: any) => (_unref(changeLocale)(loc.value)),
          key: loc.value,
          class: "mb-2 text-center cursor-pointer"
        }, [
          _createElementVNode("img", {
            src: loc.flag,
            alt: "Flag"
          }, null, 8, _hoisted_6)
        ], 8, _hoisted_5))
      }), 128))
    ])
  ]))
}
}

})